import React from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const UVIndex = ({ value }) => {
  if (value === undefined) {
    return (
      <div className="bg-white rounded-lg p-4">
        <div className="text-center text-gray-500 py-4">
          UV data not available
        </div>
      </div>
    );
  }

  const getUVColor = (value) => {
    if (value <= 2) return "#4CAF50"; // Low
    if (value <= 5) return "#FFC107"; // Moderate
    if (value <= 7) return "#FF9800"; // High
    if (value <= 10) return "#F44336"; // Very High
    return "#9C27B0"; // Extreme
  };

  const getUVDescription = (value) => {
    if (value <= 2) return "Low";
    if (value <= 5) return "Moderate";
    if (value <= 7) return "High";
    if (value <= 10) return "Very High";
    return "Extreme";
  };

  const getProtectionRecommendations = (value) => {
    if (value <= 2) return "No protection required.";
    if (value <= 5) return "Wear sunglasses and use sunscreen.";
    if (value <= 7) return "Stay in shade during midday hours.";
    if (value <= 10) return "Minimize sun exposure between 10 AM and 4 PM.";
    return "Avoid sun exposure between 10 AM and 4 PM.";
  };

  const uvColor = getUVColor(value);
  const maxUV = 12; // Maximum UV index value for the gauge

  return (
    <div className="bg-white rounded-lg p-4">
      <div className="flex flex-col items-center">
        <div className="w-32 h-32 mb-4">
          <CircularProgressbar
            value={(value / maxUV) * 100}
            text={`${value.toFixed(1)}`}
            styles={buildStyles({
              pathColor: uvColor,
              textColor: "#374151",
              trailColor: "#E5E7EB",
              textSize: "24px",
            })}
          />
        </div>
        <div className="text-center">
          <div className="text-xl font-bold" style={{ color: uvColor }}>
            {getUVDescription(value)}
          </div>
          <p className="text-sm text-gray-600 mt-2">
            {getProtectionRecommendations(value)}
          </p>
        </div>
      </div>
    </div>
  );
};

export default UVIndex;
